
















































































































































































































































































































































































































































































































































































































































































































































































































import {
  createComponent,
  inject,
  onMounted,
  computed,
  ref
} from "@vue/composition-api";
import DisplayUIKey from "@/components/display-ui-key";
import CompanyRecruitmentKey from "@/components/company-recruitment-key";
import FeatureSearch from "../../templates/Recruitment/FeatureSearch.vue";
import SkillSearch from "../../templates/Recruitment/SkillSearch.vue";
import JobSearch from "../../templates/Recruitment/JobSearch.vue";
import FormHeader from '../../molecules/FormHeader.vue';
import RecruitmentErrorDialog from '../../../views/Recruitment/RecruitmentErrorDialog.vue'
import router from '../../../router';
import customValidator from "@/lib/customValidator.ts"

export default createComponent({
  setup() {
    const displayui = inject(DisplayUIKey);
    if (!displayui) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
    const companyRecruitment = inject(CompanyRecruitmentKey);
    if (!companyRecruitment) {
      throw new Error(`${CompanyRecruitmentKey} is not provided`);
    }
    const jobCreateForm = ref(null);
    const inputSalary = (e:string) => {
      e = e.replace(/,/g, "");
      companyRecruitment.inputSalary(e)
    }
    const inputFee = (e:string) => {
      e = e.replace(/,/g, "");
      companyRecruitment.inputFee(e)
    }

    const inputCreateDateFrom = (e:string) => {
      companyRecruitment.inputCreateDateFrom(e)
    }

    const inputCreateDateTo = (e:string) => {
      companyRecruitment.inputCreateDateTo(e)
    }

    const inputCreatePostDateFrom = (e:string) => {
      companyRecruitment.inputCreatePostDateFrom(e)
    }

    const inputCreatePostDateTo = (e:string) => {
      companyRecruitment.inputCreatePostDateTo(e)
    }
    
    const renderJobTypeSelect = companyRecruitment.renderJobTypeSelect
    const renderJobSkillSelect = companyRecruitment.renderJobSkillSelect
    const renderFeatureSelect = companyRecruitment.renderFeatureSelect
    const getListPrefecture = companyRecruitment.getListPrefecture;
    const getListCity = companyRecruitment.getListCity;
    const searchPostalCode = async(postal1: any, postal2: any) => {
      const address = await companyRecruitment.searchPostalCode(postal1,postal2) as any
      if(address.data){
        await displayui.openDialogRecruitmentError();
      }else {
        
        await companyRecruitment.getCityByPostalCode()
      }
    }

    const clearJobSelected = companyRecruitment.clearJobSelected
    onMounted(() => {
      companyRecruitment.clearCreateJobParams(),
      getListPrefecture(),
      renderJobTypeSelect(),
      renderJobSkillSelect(),
      renderFeatureSelect(),
      clearJobSelected()
    });

    const addJob = async(id: any) => {
      //@ts-ignore
      if(!jobCreateForm.value.validate()){
        return;
      }
      const addNewJob = await companyRecruitment.addJob(id)
      if(addNewJob){
        await displayui.openDialogRecruitmentError();
        await companyRecruitment.resetCreteJobFlag()
      }else {
        companyRecruitment.clearCreateJobParams()
        router.push('/company_offer')
      }
    }
    
    const onFilePicked1 = companyRecruitment.onFilePicked1
    const onFilePicked2 = companyRecruitment.onFilePicked2
    const onFilePicked3 = companyRecruitment.onFilePicked3
    const deleteImage = (index: any) => {
      let a = document.getElementById("image"+index) as any
      a.value = ''
      companyRecruitment.deleteImage(index)
    }
    const jobInfor = computed(() => companyRecruitment.createJobInfor);
    const totalPayment = computed(() => companyRecruitment.totalPaymentCreateJob);
    const createJobData = computed(() => companyRecruitment.createJobInfor.createJobData);
    const prefectures = computed(() => companyRecruitment.prefectureName);
    const municipalities = computed(() => companyRecruitment.municipalitiName);
    const selectTransCost = companyRecruitment.selectTransCost;

    const openJobSearchDialog = computed(() => displayui.openJobSearchDialog);
    const openDialogFeatureSearch = computed(() => displayui.openFeatureSearchDialog);
    const skills = computed(()=> companyRecruitment.skillSearch.selected.map((item: {small_name: string})=> item.small_name).join("\n"));
    const featuresSearch = computed(()=> companyRecruitment.featureSearch.selected.map((item: {small_name: string})=> item.small_name).join("\t"));
    const jobSearch =computed(()=> companyRecruitment.jobSearch.selected.map((item: {job_small_name: string})=> item.job_small_name).join("\t"));
    const openDialogSkillSearch = computed(() => displayui.openSkillSearchDialog);
    const formatNumber = (number: string) => displayui.formatNumber(number)
    const formatDate = (date: string) => displayui.formatDate(date)
    return {
      inputSalary,
      inputFee,
      jobInfor,
      openJobSearchDialog,
      openDialogFeatureSearch,
      openDialogSkillSearch,
      getListCity,
      createJobData,
      prefectures,
      municipalities,
      totalPayment,
      onFilePicked1,
      onFilePicked2,
      onFilePicked3,
      deleteImage,
      addJob,
      searchPostalCode,
      selectTransCost,
      skills,
      featuresSearch,
      jobSearch,
      formatNumber,
      formatDate,
      inputCreateDateFrom,
      inputCreateDateTo,
      inputCreatePostDateFrom,
      inputCreatePostDateTo,
      jobCreateForm,
      customValidator 
    };
  },
  components: {
    FeatureSearch,
    SkillSearch,
    JobSearch,
    FormHeader,
    RecruitmentErrorDialog
  },
})
